import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { injectLocalDialogCloseEmitter } from '@ral/ui:aui/dialog';
import { injectEnvironment } from '@ral/utils:abp';
import { aptMutationDefaultErrorHandler, AptMutationOptions } from '@ral/utils:core/data';
import { injectToastService } from '@ral/utils:core/toast';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { AntonycoWebInquiryDtoCreateInquiryInputDto, InquiryService } from '../infrastructure';
import { Configuration } from '../infrastructure/configuration';

export function injectInquiryCreateMutation(
    options: AptMutationOptions<AntonycoWebInquiryDtoCreateInquiryInputDto, unknown> = {
        i18n: {
            errorToastTitle: 'Požadavek se nepodařilo odeslat',
            errorToastMessage: 'Zkuste to znovu',
        },
    }
) {
    const datasource = new InquiryService(
        inject(HttpClient),
        injectEnvironment().getApiUrl(undefined),
        new Configuration()
    );
    const toastService = injectToastService();

    const dialogCloseEmitter = injectLocalDialogCloseEmitter();

    const defaultErrorHandler = aptMutationDefaultErrorHandler(options);

    return injectMutation(() => ({
        mutationFn: (input: AntonycoWebInquiryDtoCreateInquiryInputDto) =>
            lastValueFrom(datasource.inquiryCreate(input)),
        ...options,
        onSuccess: async (client, variables, context) => {
            dialogCloseEmitter();
            toastService.success({
                title: 'Požadavek byl odeslán',
                message: 'Váš pozadavek zpracováváme, brzy Vás kontaktujeme',
            });
            options?.onSuccess?.(client, variables, context);
        },
        onError: options?.onError ?? defaultErrorHandler,
    }));
}
